import { EventEmitter } from 'events';

const eventEmitter = new EventEmitter();

export const navigateToLogin = () => {
  eventEmitter.emit('navigate', '/login');
};

export default eventEmitter;
